import { FC } from 'react'
import { flightDate, flightTime } from '../../../utils'
import {
  OrderDetailPurchaseSpanBold,
  OrderDetailPurchaseSpanRegular,
  OrderDetailPurchaseTitleSeparator,
} from '../../order/order.styled'
import {
  OderPurchaseTitle,
  OrderPurchaseDate,
  OrderPurchaseDepartureArrival,
  OrderPurchaseDepartureArrivalSeparator,
  OrderPurchaseDetailsArrival,
  OrderPurchaseItem,
  OrderPurchaseTitleItem,
} from '../order-mobile.styled'
import { OrderPurchaseProps } from './order-purchase.types'
import { useTranslation } from 'react-i18next'

export const OrderPurchase: FC<OrderPurchaseProps> = ({ items }) => {
  const { t } = useTranslation()

  return (
    <div>
      <OderPurchaseTitle>
        <OrderDetailPurchaseSpanRegular>
        {t('Purchase details')}
        </OrderDetailPurchaseSpanRegular>
      </OderPurchaseTitle>
      {items.map((item, index) => (
        <OrderPurchaseItem key={index}>
          <OrderPurchaseTitleItem>
            <OrderDetailPurchaseSpanRegular>
            {t('Departure Flight')}:{' '}
              <OrderDetailPurchaseSpanBold>
                {item.flight_number}
              </OrderDetailPurchaseSpanBold>
            </OrderDetailPurchaseSpanRegular>
            <OrderPurchaseDate>
              <OrderDetailPurchaseSpanRegular>
                {flightDate(item.departure_datetime)}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseTitleSeparator />
              <OrderDetailPurchaseSpanRegular>
                {flightTime(item.departure_datetime)}
              </OrderDetailPurchaseSpanRegular>
            </OrderPurchaseDate>
          </OrderPurchaseTitleItem>
          <div>
            <OrderPurchaseDepartureArrival>
              <OrderDetailPurchaseSpanBold>
              {t('Departure')}: {item.departure_airport}
              </OrderDetailPurchaseSpanBold>
              <OrderPurchaseDepartureArrivalSeparator />
              <OrderDetailPurchaseSpanBold>
                {t('Arrival')}: {item.arrival_airport}
              </OrderDetailPurchaseSpanBold>
            </OrderPurchaseDepartureArrival>
            <OrderPurchaseDetailsArrival>
              <OrderDetailPurchaseSpanRegular>
              {t('Time zone')}: {item.departure_airport_timezone}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseSpanRegular>
                {t('Carrier code')}: {item.carrier_code}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseSpanRegular>
                {t('Fare basis code')}: {item.fare_basis_code}
              </OrderDetailPurchaseSpanRegular>
              <OrderDetailPurchaseSpanRegular>
                {t('Fare class code')}: {item.fare_class_code}
              </OrderDetailPurchaseSpanRegular>
            </OrderPurchaseDetailsArrival>
          </div>
        </OrderPurchaseItem>
      ))}
    </div>
  )
}
